import { Component } from 'react';
import { connect } from 'react-redux';

import { setChatPanelVisible } from '../../reducers/ui/actions';

class WebChat extends Component {
  componentWillMount() {
    window.addEventListener('message', e => {
      if (e.data.type === 'setWebChatOpenState') {
        this.props.setChatPanelVisible(e.data.chatPanelOpen);
      }
    });
  }

  render() {
    return null;
  }
}

export default connect(null, { setChatPanelVisible })(WebChat);



// WEBPACK FOOTER //
// ./src/components/OpenStateListener/index.js